import styled from 'styled-components';
import TripAdvisorIconSvg from '../assets/hotels/tripadvisor-icon.svg';

const TripAdvisorIcon = styled(TripAdvisorIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  padding: ${props => props.padding || '0 0.4rem 0 0'};
  /* margin: ${props => props.margin}; */
  cursor: pointer;
`;

export default TripAdvisorIcon;
